/* eslint-disable @typescript-eslint/no-explicit-any */
// ─── components/GoogleScripts.tsx ───────────────────────────────────────────
"use client";

import Script from "next/script";

export default function GoogleScripts() {
  return (
    <>
      {/* Google Drive API config — must run before the two SDKs below */}
      <Script id="google-drive-config" strategy="beforeInteractive">
        {`
          var G_CLIENT_ID = "12844907838-3op9vg2ovaf44k5b69lo5qbco76ju0jo.apps.googleusercontent.com";
          var G_API_KEY = "AIzaSyCApjAtqywlMTNIe4LZdowa1E3Uv2YyIOs";
          var G_CLIENT_SECRET = "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";
          var DISCOVERY_DOC = "https://www.googleapis.com/discovery/v1/apis/drive/v3/rest";
          var SCOPES = ["https://www.googleapis.com/auth/drive.appdata", "profile", "email"].join(" ");

          var codeClient;
          var gapiInited = false;
          var gisInited = false;
          var G_LIB_READY = false;

          function gapiLoaded() {
            gapi.load("client", initializeGapiClient);
          }

          async function initializeGapiClient() {
            try {
              await gapi.client.init({
                apiKey: G_API_KEY,
                discoveryDocs: [DISCOVERY_DOC],
              });
              var token = localStorage.getItem("gapi_token");
              if (token) {
                gapi.client.setToken({ access_token: token });
              }
              gapiInited = true;
              maybeGREADY();
            } catch (err) {
              console.log("initializeGapiClient error: " + err.message);
            }
          }

          function gisLoaded() {
            codeClient = google.accounts.oauth2.initCodeClient({
              client_id: G_CLIENT_ID,
              scope: SCOPES,
              callback: "",
              ux_mode: "popup",
            });
            gisInited = true;
            maybeGREADY();
          }

          function maybeGREADY() {
            if (gapiInited && gisInited) {
              G_LIB_READY = true;
            }
          }
        `}
      </Script>

      {/* Google API JS */}
      <Script
        src="https://apis.google.com/js/api.js"
        strategy="afterInteractive"
        onLoad={() => {
          if (typeof window !== "undefined" && typeof (window as any).gapiLoaded === "function") {
            (window as any).gapiLoaded();
          }
        }}
      />

      {/* Google Identity Services */}
      <Script
        src="https://accounts.google.com/gsi/client"
        strategy="afterInteractive"
        onLoad={() => {
          if (typeof window !== "undefined" && typeof (window as any).gisLoaded === "function") {
            (window as any).gisLoaded();
          }
        }}
      />
    </>
  );
}


